import { DepartmentTransferResult } from '../../domain/models/department-transfer-result.model';
import { DepartmentTransferResultDto } from '../dtos/department-transfer-result.dto';

// A plain function rather than an `@Injectable` mapper: the two repositories that call it live in
// different features, and registering one more provider in each feature's data providers buys
// nothing for a pure five-field projection.
export function toDepartmentTransferResult(dto: DepartmentTransferResultDto): DepartmentTransferResult {
  return {
    clientExternalId: dto.ClientExternalId,
    departmentId: dto.DepartmentId,
    movedPatientExternalIds: dto.MovedPatientExternalIds ?? [],
    alreadyInDepartmentPatientExternalIds: dto.AlreadyInDepartmentPatientExternalIds ?? [],
    appClientSynced: dto.AppClientSynced,
  };
}
